import { useState } from "react";
import "./appHeader.css";

const PATHS = {
  clientes: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M16 3a4 4 0 0 1 0 8 M22 21v-2a4 4 0 0 0-3-3.87 M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
  agenda: "M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2 M8 14h2 M14 14h2 M8 18h2",
  impressoras: "M6 8V3h12v5 M6 17H3V8h18v9h-3 M6 14h12v7H6z M17 11h1",
  filamentos: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0 M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0 M12 3v5 M12 16v5 M3 12h5 M16 12h5",
  materiais: "m12 3 9 5-9 5-9-5 9-5Z M3 12l9 5 9-5 M3 16l9 5 9-5",
  notas: "M15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9 M8 8h4 M8 12h3 M8 16h8 M16 3l5 5h-5V3Z",
  config: "M4 7h9 M17 7h3 M4 17h3 M11 17h9 M17 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0 M11 17a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
  busca: "M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0 M15 15l6 6",
  grid: "M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z",
  cube: "m12 3 9 5v9l-9 5-9-5V8l9-5Z m-9 5 9 5 9-5 M12 13v9 M7.5 5.5l9 5",
  arrow: "M7 17 17 7 M7 7h10v10",
  close: "m6 6 12 12 M6 18 18 6",
};

export function HeaderIcon({ name, size = 22, className }) {
  return <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={PATHS[name] || PATHS.cube} /></svg>;
}

export function CompanyBrand({ empresa, logo, subtitle, compact = false }) {
  const [failedLogo, setFailedLogo] = useState(null);
  const name = empresa || "Print Control";
  return <div className={`pc-company${compact ? " pc-company--compact" : ""}`}>
    <span className="pc-company-mark" aria-hidden="true">
      {logo && failedLogo !== logo ? <img src={logo} alt="" onError={() => setFailedLogo(logo)} /> : <HeaderIcon name="cube" size={compact ? 23 : 29} />}
    </span>
    <div className="pc-company-copy">
      {!compact && <span className="pc-company-eyebrow">PRINT CONTROL <span>/</span> SEU ESTÚDIO</span>}
      <strong title={name}>{name}</strong>
      <span className="pc-company-subtitle">{subtitle || "Da ideia à próxima impressão."}</span>
    </div>
  </div>;
}

export function LogoutButton({ onClick }) {
  return <button type="button" className="pc-logout" onClick={onClick} aria-label="Sair da conta" title="Sair da conta">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M10 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5" />
      <path className="pc-logout-arrow" d="M9 12h12 m-4-4 4 4-4 4" />
    </svg><span>Sair</span>
  </button>;
}

export function AppHeader({ empresa, logo, nome, avatar, items, active = {}, onAction, onLogout, clientesBadge = 0, impressorasCount, hint, version }) {
  return <header className="pc-workspace-header">
    <div className="pc-workspace-top">
      <CompanyBrand empresa={empresa} logo={logo} subtitle={version ? `Seu espaço de impressão 3D · v${version}` : undefined} />
      <div className="pc-header-side">
        {/* Ferramentas no canto, só com o ícone (o nome aparece ao passar o mouse) */}
        <nav className="pc-header-tools" aria-label="Ferramentas do estúdio">
          {items.filter(item => item.id !== "busca").map(item => <div className="pc-header-tool-wrap" key={item.id}>
            <button type="button" className={`pc-header-tool${active[item.id] ? " is-active" : ""}`} data-tour={`nav-${item.id}`} style={{ "--shortcut-color": item.color }} title={item.label} aria-label={item.label} aria-pressed={!!active[item.id]} onClick={() => onAction(item.id)}>
              <span className="pc-header-tool-icon"><HeaderIcon name={item.id} size={20} />
                {item.id === "clientes" && clientesBadge > 0 && <span className="pc-header-tool-badge" aria-label={`${clientesBadge} novidades`}>{clientesBadge > 99 ? "99+" : clientesBadge}</span>}
                {item.id === "impressoras" && impressorasCount === 0 && <span className="pc-header-tool-dot" aria-label="Nenhuma impressora cadastrada" />}
              </span>
            </button>
            {item.id === "config" && hint}
          </div>)}
        </nav>
        <div className="pc-header-account">
          <span className="pc-header-avatar" aria-hidden="true">{!avatar || avatar === "👤" ? "🧑‍💻" : avatar}</span>
          <div className="pc-header-person"><small>Bom ter você por aqui</small><strong title={nome}>{nome || "Minha conta"}</strong></div>
          <LogoutButton onClick={onLogout} />
        </div>
      </div>
    </div>
  </header>;
}
